import React from 'react';
import { Skeleton } from 'antd';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../redux/store';
import { SectionContent, SectionTitle, SectionText, EmptyState, EmptyStateText } from './Styles';
import { EMPTY_STATE_MESSAGES } from './constants';

const CustomerFeedbackSection: React.FC = () => {
  const { customerFeedback, loading } = useSelector(
    (state: RootState) => state.managerReports
  );

  if (loading.customerFeedback) {
    return (
      <SectionContent>
        <Skeleton active paragraph={{ rows: 4 }} />
      </SectionContent>
    );
  }

  if (!customerFeedback) {
    return (
      <EmptyState>
        <EmptyStateText>{EMPTY_STATE_MESSAGES.CUSTOMER_FEEDBACK}</EmptyStateText>
      </EmptyState>
    );
  }

  return (
    <SectionContent>
      <SectionTitle>Customer Feedback Details</SectionTitle>
      <SectionText>
        Detailed report on customer feedback including ratings, reviews, satisfaction scores,
        and trends over time.
      </SectionText>
      {/* Add more detailed content here when API data is available */}
    </SectionContent>
  );
};

export default React.memo(CustomerFeedbackSection);
